import React from "react";
import HomeContainer from "../../containers/Home";

function Home(props) {
  return <HomeContainer {...props} />;
}

export default Home;
